import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PolicyHolderActions from './policyholder.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { PolicyHolderService } from '../../services/moduleServices/policyholder.service';
import { Router } from '@angular/router';

@Injectable()
export class PolicyHolderEffects {
  registerPolicyHolder$: any;
  loadPolicyHolderById$: any;
  updatePolicyHolder$: any;
  loadAllPolicyHolders$: any;

  constructor(
    private actions$: Actions,
    private policyHolderService: PolicyHolderService,
    private router: Router
  ) {
    /**
     *    Register PolicyHolder (POST)
     */
    this.registerPolicyHolder$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PolicyHolderActions.registerPolicyHolder),
        mergeMap(({ formData }) =>
          this.policyHolderService.registerPolicyHolder(formData).pipe(
            map((response) => {
              this.router.navigate(['/user/policyholder-management']);
              return PolicyHolderActions.registerPolicyHolderSuccess({ response });
            }),
            catchError((error) =>
              of(
                PolicyHolderActions.registerPolicyHolderFailure({
                  error: error?.message || error,
                })
              )
            )
          )
        )
      )
    );


    /**
     *    Load PolicyHolder by ID (GET)
     */
    this.loadPolicyHolderById$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PolicyHolderActions.loadPolicyHolderById),
        mergeMap(({ id }) =>
          this.policyHolderService.getPolicyHolderById(id).pipe(
            map((policyholder) =>
              PolicyHolderActions.loadPolicyHolderByIdSuccess({ policyholder })
            ),
            catchError((error) =>
              of(
                PolicyHolderActions.loadPolicyHolderByIdFailure({
                  error: error?.message || error,
                })
              )
            )
          )
        )
      )
    );


    /**
     *    Update PolicyHolder (PATCH)
     */
    this.updatePolicyHolder$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PolicyHolderActions.updatePolicyHolder),
        mergeMap(({ id, changes }) =>
          this.policyHolderService.updatePolicyHolder(id, changes).pipe(
            map((policyholder) =>
              PolicyHolderActions.updatePolicyHolderSuccess({ policyholder })
            ),
            catchError((error) =>
              of(
                PolicyHolderActions.updatePolicyHolderFailure({
                  error: error?.message || error,
                })
              )
            )
          )
        )
      )
    );

    this.loadAllPolicyHolders$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PolicyHolderActions.loadAllPolicyHolders),
            mergeMap(({ filters }) =>
            this.policyHolderService.getAllPolicyHolders(filters).pipe(
                map((response) => {
                const list = response?.value || response || [];
                return PolicyHolderActions.loadAllPolicyHoldersSuccess({ policyholders: list });
                }),
                catchError((error) =>
                of(
                    PolicyHolderActions.loadAllPolicyHoldersFailure({
                    error: error?.message || error,
                    })
                )
                )
            )
            )
        )
        );
  }
}
